import { useCallback, useMemo } from 'react';

import { CrownLetter } from './components/CrownLetter';
import classes from './TextWithCrown.module.scss';

export type TextWithCrownProps = {
  text: string;
  crownLetters: string[];
  crownLettersPositions?: number[];
  style?: React.CSSProperties;
  letterStyle?: React.CSSProperties;
  crownStyle?: React.CSSProperties;
  crownFill?: string;
  crownSymbolPosition?: number;
};

export function TextWithCrowns({
  text,
  crownLetters,
  crownLettersPositions,
  style,
  crownFill,
  letterStyle,
  crownStyle,
  crownSymbolPosition,
}: TextWithCrownProps) {
  const letters = text.split('');
  const isCrown = useCallback(
    (letter: string, index: number) =>
      Boolean(crownLetters.includes(letter.toLocaleLowerCase()) || crownLettersPositions?.includes(index)),
    [crownLetters, crownLettersPositions],
  );
  const hasCrownLetter = useMemo(() => letters.some((letter, index) => isCrown(letter, index)), [isCrown, letters]);

  const showCrown = (letter: string, index: number) => {
    if (hasCrownLetter) {
      return isCrown(letter, index);
    }
    return crownSymbolPosition === index;
  };

  return (
    <div className={classes.textWithCrowns} style={style}>
      {letters.map((letter, index) => {
        if (letter === '\n') {
          return <br key={index} />;
        }
        return (
          <CrownLetter
            key={index}
            crownFill={crownFill}
            crownStyle={crownStyle}
            isCrown={showCrown(letter, index)}
            letter={letter}
            style={letterStyle}
          />
        );
      })}
    </div>
  );
}
